import React from "react";

import { Trash} from "react-bootstrap-icons";

import Checkbox from "./help/Checkbox";
import Number from "./help/Number";

function ValuesList({
    items = [],
    onChange,
    onDelete
}) {
    const getComponent = (item, index) => {
        switch (item.type) {
            case "number":
                return <Number 
                    item={item}
                    onChange={onChange ? (e) => onChange(e, index) : undefined}
                />;
            case "checkbox":
                return <Checkbox 
                    item={item}
                    onChange={onChange ? (e) => onChange(e, index) : undefined}
                />;
            default:
                return null;
        }
    };


    return (
        <ul className="list-group list-group-flush w-100">
            {items.map((item, index) => {
                return (
                    <li 
                        key={index} 
                        className="list-group-item w-100 p-0"
                        style={{
                            marginTop: '4px',
                            marginBottom: '4px'
                        }}
                    >
                        <div 
                            className="d-flex align-items-center gap-2"
                            style={{ 
                                padding: '4px' 
                            }}
                        >
                            {getComponent(item, index)}

                            {onDelete && (
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger align-self-end mb-2"
                                    onClick={() => onDelete(index)}
                                >
                                    <Trash size={16} />
                                </button>
                            )}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default ValuesList;